import { createApp } from 'vue';
import App from './App.vue';
import './assets/tailwind.css';
import { useDbStore } from './stores/dbStore'
import { createPinia } from 'pinia';

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);

const dbStore = useDbStore()
dbStore.fetchData()

app.mount('#app');